var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpIco2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.493,
    height: 11.145,
    viewBox: "0 0 11.493 11.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emp-ico-2",
    transform: "translate(-1.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M10.566,10.645a.206.206,0,0,1-.1-.024L7.68,9.131l-.235-.126-.235.126L4.417,10.622a.2.2,0,0,1-.288-.208l.535-3.17.043-.256-.185-.183L2.255,4.561a.2.2,0,0,1-.048-.2.2.2,0,0,1,.158-.131l3.124-.461.261-.039.115-.238L7.265.61a.2.2,0,0,1,.353,0l1.4,2.881.115.238.261.039,3.128.461a.2.2,0,0,1,.109.334L10.364,6.805l-.185.183.043.256.538,3.171a.2.2,0,0,1-.082.193A.19.19,0,0,1,10.566,10.645Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M7.442,1.39,6.085,4.183l-3.046.45L5.244,6.815,4.724,9.891l2.72-1.452,2.72,1.452L9.643,6.815l2.205-2.182L8.8,4.183,7.442,1.39m0-1.39a.7.7,0,0,1,.627.392l1.4,2.879,3.128.461a.7.7,0,0,1,.387,1.184L10.716,7.161l.538,3.171a.7.7,0,0,1-1.016.731L7.445,9.572,4.652,11.063a.7.7,0,0,1-1.016-.731l.535-3.171L1.9,4.917a.7.7,0,0,1,.387-1.184l3.125-.461L6.816.392A.7.7,0,0,1,7.442,0Z",
    fill: "#7e7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpIco2);
export default __webpack_public_path__ + "static/media/emp-ico-2.15b3842e408c9dffecc939abb9b330b3.svg";
export { ForwardRef as ReactComponent };